import { HttpTask } from '@core/http';
import httpService from '@core/http/service';
import { TrackingParams } from '@modules/tracking/model';

const URI = '/tracking';

export function tracking(params: TrackingParams): HttpTask {
  return httpService.post(URI, params);
}
